<template>
  <div class="item">
    <div class="item-header">
      <div class="item-header-title">SERVICES SOLUTIONS</div>
      <div class="item-header-name">
        <span class="item-header-name-line" />
        <span>服务</span>
        <span class="bold">解决方案</span>
        <span class="item-header-name-line" />
      </div>
      <div class="item-header-desc">拥有咨询、规划、设计、实施、服务一体化的交付能力。</div>
    </div>

    <div class="item-content">
      <div class="scale-items">
        <div class="scale-item" @click="handleClick(1)">
          <div class="scale-item-wrap scale1">
            <div class="scale-item-name">咨询与规划</div>
            <div class="scale-item-sub">Consulting and design</div>
            <div class="scale-item-desc">Mobirise gives you the freedom to develop as many websites as you like given the fact that it is a desktop app.</div>
            <div class="scale-item-btn">详细了解</div>
          </div>
        </div>
        <div class="scale-item" @click="handleClick(2)">
          <div class="scale-item-wrap scale2">
            <div class="scale-item-name">迁移和部署</div>
            <div class="scale-item-sub">Migration and deployment</div>
            <div class="scale-item-desc">Mobirise gives you the freedom to develop as many websites as you like given the fact that it is a desktop app.</div>
            <div class="scale-item-btn">详细了解</div>
          </div>
        </div>
        <div class="scale-item" @click="handleClick(3)">
          <div class="scale-item-wrap scale3">
            <div class="scale-item-name">运维与管理</div>
            <div class="scale-item-sub">Operation and management</div>
            <div class="scale-item-desc">Mobirise gives you the freedom to develop as many websites as you like given the fact that it is a desktop app.</div>
            <div class="scale-item-btn">详细了解</div>
          </div>
        </div>
        <div class="scale-item" @click="handleClick(4)">
          <div class="scale-item-wrap scale4">
            <div class="scale-item-name">优化与提升</div>
            <div class="scale-item-sub">Optimization and enhancement</div>
            <div class="scale-item-desc">Mobirise gives you the freedom to develop as many websites as you like given the fact that it is a desktop app.</div>
            <div class="scale-item-btn">详细了解</div>
          </div>
        </div>
        <div class="scale-item" @click="handleClick(5)">
          <div class="scale-item-wrap scale5">
            <div class="scale-item-name">培训和认证</div>
            <div class="scale-item-sub">Training and certification</div>
            <div class="scale-item-desc">Mobirise gives you the freedom to develop as many websites as you like given the fact that it is a desktop app.</div>
            <div class="scale-item-btn">详细了解</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  methods: {
    handleClick (i) {
      this.$router.push(`/help`)
      setTimeout(() => {
        window.location.hash = `#help${i}`
      })
    }
  }
}
</script>

<style lang="less" scoped>
.scale-items {
  display: flex;
}
.scale-item {
  text-align: center;
}

.scale1 {
  background: url('../../assets/images/home/scale-1.png');
}

.scale2 {
  background: url('../../assets/images/home/scale-2.png');
}

.scale3 {
  background: url('../../assets/images/home/scale-3.png');
}

.scale4 {
  background: url('../../assets/images/home/scale-4.png');
}

.scale5 {
  background: url('../../assets/images/home/scale-5.png');
}

.scale-item-wrap {
  width: 164px;
  height: 450px;
  color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  transition: all .5s ease-in-out;
  transform-origin: 50% 50%;
  margin: 0 auto;

  @media (min-width: 1280px) and (max-width: 1680px){
    width: 246px;
    height: 675px;
  }
        
  @media screen and (min-width: 1920px){
    width: 328px;
    height: 900px;
  }

  .scale-item-name {
    font-size: 16px;
    transition: all .5s ease-in-out;
    transform: translateY(220px);

    @media (min-width: 1280px) and (max-width: 1680px){
      font-size: 24px;
      transform: translateY(330px);
    }
          
    @media screen and (min-width: 1920px){
      font-size: 32px;
      transform: translateY(440px);
    }
  }

  .scale-item-sub {
    font-size: 8px;
    transition: all .5s ease-in-out;
    transform: translateY(230px);

    @media (min-width: 1280px) and (max-width: 1680px){
      font-size: 14px;
      transform: translateY(345px);
    }
          
    @media screen and (min-width: 1920px){
      font-size: 16px;
      transform: translateY(460px);
    }
  }
  
  .scale-item-desc {
    opacity: 0;
    transition: all .5s ease-in-out;
    transform: translateY(260px);
    padding: 0 8px;

    @media (min-width: 1280px) and (max-width: 1680px){
      transform: translateY(390px);
      padding: 0 12px;
    }
          
    @media screen and (min-width: 1920px){
      transform: translateY(520px);
      padding: 0 16px;
    }
  }

  .scale-item-btn {
    width: 96px;
    height: 28px;
    border-radius: 14px;
    background-color: #f45937;
    color: #fff;
    font-size: 9px;
    line-height: 28px;
    text-align: center;
    margin-top: 20px;
    transition: all .5s ease-in-out;
    transform: translateY(300px);
    opacity: 0;
    cursor: pointer;

    @media (min-width: 1280px) and (max-width: 1680px){
      width: 144px;
      height: 42px;
      border-radius: 21px;
      font-size: 14px;
      line-height: 42px;
      margin-top: 30px;
    }
          
    @media screen and (min-width: 1920px){
      width: 192px;
      height: 56px;
      border-radius: 28px;
      font-size: 18px;
      line-height: 56px;
      margin-top: 40px;
    }
  }
}

.scale-item:hover {
  .scale-item-wrap {
    width: 304px;
    @media (min-width: 1280px) and (max-width: 1680px){
      width: 456px;
    }
          
    @media screen and (min-width: 1920px){
      width: 608px;
    }
  }
  .scale-item-name {
    transform: translateY(100px);

    @media (min-width: 1280px) and (max-width: 1680px){
      transform: translateY(150px);
    }
          
    @media screen and (min-width: 1920px){
      transform: translateY(200px);
    }
    
  }
  .scale-item-sub {
    transform: translateY(110px);

    @media (min-width: 1280px) and (max-width: 1680px){
      transform: translateY(165px);
    }
          
    @media screen and (min-width: 1920px){
      transform: translateY(220px);
    }
  }
  .scale-item-desc {
    transform: translateY(140px);
    opacity: 1;

    @media (min-width: 1280px) and (max-width: 1680px){
      transform: translateY(210px);
    }
          
    @media screen and (min-width: 1920px){
      transform: translateY(280px);
    }
  }
  .scale-item-btn {
    transform: translateY(180px);
    opacity: 1;
    cursor: pointer;

    @media (min-width: 1280px) and (max-width: 1680px){
      transform: translateY(270px);
    }
          
    @media screen and (min-width: 1920px){
      transform: translateY(360px);
    }
  }
}
</style>